Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'agent_ad',
  '.sc-agent-ad',

  /**
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {
  const $this = $(el);
  const $iframe = $this.find(`${selector}__iframe`);
  let iframeOrigin;

  /**
   * Initialize the widget
   */
  (function init() {
    setUrlParams();
    addEvents();
  })();

  /**
   * Builds the iframe src URL by appending geo and visitor tracking params
   * from the model and cookie, then sets it on the iframe element.
   */
  function setUrlParams() {
    const url = new URL(model.src);
    const visitorId = Cookies.get('__vst') || null;

    if (model.zip_code) {
      url.searchParams.set('zip_code', model.zip_code);
    }

    if (model.city) {
      url.searchParams.set('city', model.city);
    }

    if (model.state_code) {
      url.searchParams.set('state', model.state_code);
    }

    if (model.region_name) {
      url.searchParams.set('location_string', model.region_name);
    }

    if (visitorId) {
      url.searchParams.set('rdc_visitor_id', visitorId);
    }

    iframeOrigin = url.origin;
    $iframe.attr('src', url.toString());
  }

  /**
   * Handle UI events
   */
  function addEvents() {
    window.addEventListener('message', onMessage);
  }

  /**
   * Applies the height the widget reports via postMessage to this instance's --iframe-height.
   *
   * @param {MessageEvent} event
   */
  function onMessage(event) {
    if (event.origin !== iframeOrigin || event.source !== $iframe[0].contentWindow) {
      return;
    }

    const data = event.data;

    if (data?.type !== 'rdc:widget:height' || !Number.isFinite(data.height)) {
      return;
    }

    $this.css('--iframe-height', data.height + 'px');
  }

});
